import React, { Fragment, FunctionComponent, useEffect } from 'react';
import "../error.scss"
import Text from '../../../components/typography/typgraphy';

const NoAccountError: FunctionComponent = () => {
 

  return (
    <Fragment>
      <Text className="error-description">Seems like you don’t have a valid savings account with us for this transaction.</Text>
      <Text className="error-description">Please visit our nearest branch for more details.</Text>
    </Fragment>
  )
}

export default NoAccountError;
